export default __webpack_public_path__ + "static/media/Img2.390090bc.jpg";